import * as types from '../types.js';

export default {

	html: `
		<style>
			#category #company_id	{ width: 10rem;		}
			#category #id			{ width: 4.5rem; text-align: right;	}
			#category #name			{ width: 10rem;		}
			#category .name 		{ width: 14rem;		}
			#category .length 		{ width: 5rem; text-align: right;	}
			#category .attr-help		{ margin: 0.5rem 0 1rem; padding: 0.75rem; background: var(--form-hint-bg, #f5f5f5); border-radius: 4px; font-size: 0.9rem; line-height: 1.4; }
			#category .attr-help code { padding: 0.1em 0.4em; background: #e0e0e0; border-radius: 3px; font-size: 0.9em; }
			#category .attr-section th small { font-weight: normal; color: #666; display: block; margin-top: 0.2rem; }
		</style>
		<form id="category" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da categoria">Categoria
					<input id="id" type="text" disabled>
				</label>
				<label title="Nome da categoria">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
			</div>
			<div class="attr-section">
				<p class="attr-help">
					<strong>Estrutura do SKU:</strong> Os atributos definem como o código do produto (SKU) será organizado.
					Cada linha é um segmento do SKU. O <em>tamanho</em> indica quantos caracteres esse segmento terá.
					Ex.: com atributos <strong>Substância(3)</strong>, <strong>Concentração(1)</strong>, <strong>Embalagem(1)</strong> o SKU seria algo como <code>PRD,5,C</code> (Paracetamol 500mg Comprimido).
				</p>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Atributo<sup>*</sup><br><small>Nome do segmento (ex: Substância, Concentração)</small></th>
							<th>Tamanho<sup>*</sup><br><small>Qtd. caracteres no SKU (1–12)</small></th>
							<th>Opcional<br><small>Pode ficar em branco?</small></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row" data-size="6">
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Nome do atributo exibido no cadastro do produto (ex: Substância, Fabricante)">
								<input id="name-0" class="name" type="text" required placeholder="ex: Produto">
							</td>
							<td title="Quantidade de caracteres deste segmento no código SKU">
								<input id="length-0" class="length" type="text" required placeholder="ex: 6">
							</td>
							<td title="Marcar se este atributo pode ser omitido no SKU">
								<input id="is_optional-0" class="optional" type="checkbox">
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de seleção">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conteúdo das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#category',
		init(formset)	// Must not be async as init seq must be preserved
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#name' }, types: [types.name()] },
		{ properties: { selector: '#checkbox-0' }, types: [types.checkbox()] },
		{ properties: { selector: '#name-0' }, types: [types.name()] },
		{ properties: { selector: '#length-0' }, types: [types.number(0, 2)]},
		{ properties: { selector: '#is_optional-0' }, types: [types.checkbox()] },
	]

};

